import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue";
var _hoisted_1 = ["onClick"];
import { ActivityScene } from '@/router';
import { useNavigation } from '../util/navigation';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var _useNavigation = useNavigation(),
      toReplace = _useNavigation.toReplace,
      toNavBack = _useNavigation.toBack;
    // eslint-disable-next-line max-len
    var getScene = function getScene(component) {
      var _component$type;
      return (component === null || component === void 0 || (_component$type = component.type) === null || _component$type === void 0 ? void 0 : _component$type.scene) || ActivityScene.Activity;
    };
    var toBack = function toBack(component) {
      var _component$type2, _component$type3;
      if ((component === null || component === void 0 || (_component$type2 = component.type) === null || _component$type2 === void 0 ? void 0 : _component$type2.clickModalClose) === false) return;
      if (component !== null && component !== void 0 && (_component$type3 = component.type) !== null && _component$type3 !== void 0 && _component$type3.replaceUrl) {
        var _component$type4;
        toReplace(component === null || component === void 0 || (_component$type4 = component.type) === null || _component$type4 === void 0 ? void 0 : _component$type4.replaceUrl);
        return;
      }
      toNavBack();
    };
    return function (_ctx, _cache) {
      var _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createBlock(_component_router_view, null, {
        "default": _withCtx(function (_ref) {
          var Component = _ref.Component;
          return [_createVNode(_Transition, null, {
            "default": _withCtx(function () {
              return [getScene(Component) !== _unref(ActivityScene).Activity ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                "class": "animation-opacity",
                onClick: function onClick($event) {
                  return toBack(Component);
                }
              }, null, 8, _hoisted_1)) : _createCommentVNode("", true)];
            }),
            _: 2
          }, 1024), _createVNode(_Transition, {
            name: "animation",
            mode: "out-in"
          }, {
            "default": _withCtx(function () {
              return [(_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                scene: getScene(Component)
              }, null, 8, ["scene"]))];
            }),
            _: 2
          }, 1024)];
        }),
        _: 1
      });
    };
  }
});